const MAX_WEEK_ROWS = 6;
const WEEK_ROW_GAP_PX = 8;

export const getMonthWeeksMinHeightPx = (dayRowHeightPx: number): number =>
  MAX_WEEK_ROWS * dayRowHeightPx + (MAX_WEEK_ROWS - 1) * WEEK_ROW_GAP_PX;
